import React from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate';
import { useTextResources } from '../../../language';
import { Guests } from '../../../api/services/next';
import moment from 'moment'
import { Form } from 'semantic-ui-react';
import TextInput from '../../shared/TextInput';
import { dateFormat } from '../../shared/constants';

export const GuestReport = ()=>{
    const text = useTextResources()
    const dateFormatter = ({value})=>{
        return value&&moment(value).format(dateFormat) || null
    }

    const customizeExcelHeader = (worksheet) => {
        const row = worksheet.addRow([text("GuestReport")]);
        worksheet.mergeCells('A1:O1');
        row.height = 20;
        row.font = { bold: true, size: 16 };
    };

    const gridOptions = {
        search: {
            title: text("GuestReport"),
            fields: [ 
                <Form.Field
                key='FirstName'
                label={text('FirstName')}
                clearable
                control={TextInput}
                placeholder={text('FirstName')}
                />,
                <Form.Field
                key='LastName'
                label={text('LastName')}
                clearable
                control={TextInput}
                placeholder={text('LastName')}
                />,
                <Form.Field
                key='Phone'
                label={text('Phone')}
                clearable
                control={TextInput}
                placeholder={text('Phone')}
                />,
                <Form.Field
                key='Email'
                label={text('Email')}
                clearable
                control={TextInput}
                placeholder={text('Email')}
                />
            ],
            api: Guests.GetGuests,
            spec: {
                MaxResults: 3000
            }
        },
        grid: {
            columns: [
                { name: 'FirstName', title: text("FirstName") },
                { name: 'LastName', title: text("LastName") },
                { name: 'Email', title: text("Email") },
                { name: 'BirthDate', title: text("DateOfBirth"), formatter: dateFormatter },
                { name: 'Nationality', title: text("Nationality") },
                { name: 'Language', title: text("Language") },
                { name: 'Phone', title: text("Phone") },
                { name: 'LocationId', title: text("Location") },
                { name: 'VipId', title: text("VIP") },
            ],
            paging: true,
            excel: {
                customizeHeader: customizeExcelHeader,
            },
            export: true,
        }
    }
    return (<GridSearchTemplate options={gridOptions}/>)
}
